import React, { memo } from 'react';

import { Text } from '@/components/shared/element/text';
import { Grid } from '@/components/shared/layout/grid';
import type { IParts } from '@/types/shared/parts';

interface BaseProps {
  size?: 'small' | undefined;
  dataTest?: string;
}
interface PartsRemarkProps extends BaseProps {
  parts?: IParts;
}

interface PartsRemarkTextProps extends BaseProps {
  value: string;
}

interface PartsRemarkItemsProps extends BaseProps {
  items: IParts['remarkItems'];
}

const PartsRemarkText = memo(
  ({ size, value, dataTest }: PartsRemarkTextProps) => {
    return (
      <Text
        as="p"
        size={
          size === 'small'
            ? 'text-caption'
            : { '@initial': 'text-caption', '@sm': '2xs' }
        }
        wrap
        dangerouslySetInnerHTML={{
          __html: value,
        }}
        data-test={dataTest}
      />
    );
  }
);
PartsRemarkText.displayName = 'PartsRemarkText';

export const PartsRemarkItems = memo(
  ({ items = [], size, dataTest }: PartsRemarkItemsProps) => {
    return (
      <Grid
        columnGap="2"
        css={{
          textAlign: 'left',
          '@xs': {
            gridTemplateColumns: 'max-content auto',
          },
        }}
      >
        {items.map((o, i) => (
          <React.Fragment key={i}>
            <PartsRemarkText
              value={o.year ?? ''}
              size={size}
              dataTest={dataTest + '_remark'}
            />
            <PartsRemarkText
              value={o.label ?? ''}
              size={size}
              dataTest={dataTest + '_remark'}
            />
          </React.Fragment>
        ))}
      </Grid>
    );
  }
);

export const PartsRemark = memo(
  ({ parts, size, dataTest = 'popup_partsDetail' }: PartsRemarkProps) => {
    return (
      <Grid>
        {!!parts?.remark && (
          <PartsRemarkText
            value={parts?.remark}
            size={size}
            dataTest={dataTest + '_description_remark'}
          />
        )}

        {!!parts?.remarkStick && (
          <PartsRemarkText
            value={parts?.remarkStick}
            size={size}
            dataTest={dataTest + '_description_remarkStick'}
          />
        )}

        {!!parts?.remark2 && (
          <PartsRemarkText
            value={parts?.remark2}
            size={size}
            dataTest={dataTest + '_description_remark2'}
          />
        )}
      </Grid>
    );
  }
);

PartsRemarkItems.displayName = 'SectionPartsItemPartsRemarkItems';
PartsRemark.displayName = 'SectionPartsItemPartsRemark';
